import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./Banner.module.scss";

function Banner({ children, color, height, position, fixed }) {
  const bannerClasses = classnames(
    styles.banner,
    styles[color],
    styles[height],
    styles[position],
    fixed && styles.fixed,
  );

  return <div className={bannerClasses}>{children}</div>;
}

Banner.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(["black", "cream", ""]),
  height: PropTypes.oneOf(["auto", ""]),
  position: PropTypes.oneOf(["top", "bottom"]),
  fixed: PropTypes.bool,
};

Banner.defaultProps = {
  children: null,
  color: "",
  height: "",
  position: "top",
  fixed: false,
};

export default Banner;
